import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchSchoolMembersThunk } from "../../shared/store/redux/schoolManager-actions";
import LeftSideMenu from "./leftSideMenu/LeftSideMenu";
import PermissionHoldersStrip from "../pages/rolePermissions/permissionHoldersStrip/PermissionHoldersStrip";
import classes from "./Layout.module.css";

const Layout = () => {

    const { texts } = useSelector((state) => state.translate);
    const schoolId = useSelector((state) => state.auth.userDetails?.defaultSchool?.id);
    const schoolManagers = useSelector((state) => state.schoolManager.schoolManagers);
    const dispatch = useDispatch();

    useEffect(() => {
        if (schoolId)
            dispatch(fetchSchoolMembersThunk(schoolId));
    }, [schoolId]);

    return (
        <div className={classes.LayoutWrapper}>
            <h1 className={classes.Title}>{texts.virtualSchoolManagementTitle}</h1>
            <PermissionHoldersStrip roleHolders={schoolManagers.filter(m => m.isManager) ?? []} />
            <div className={classes.Layout}>
                <LeftSideMenu />
                <div className={classes.Content}>
                    <Outlet />
                </div>
            </div>
        </div>
    );
}

export default Layout;
